import React, { useCallback, useEffect, useRef } from 'react';
import { FiUser } from 'react-icons/fi';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import getValidationErrors from '../../../utils/getValidationErrors';

import Input from '../../../components/Input';
import Button from '../../../components/Button';

import { config } from '../../../config';

import {
  Container,
  Content,
  AnimationContainer,
  Title,
  ColInput,
} from './styles';

import { CustomerData } from '../../../store/modules/auth/types';
import {
  customerConfirmMailRequest,
  customerSendMailRequest,
} from '../../../store/modules/auth/actions';

import { StoreState } from '../../../store/createStore';
import { routesEndpoints } from '../../../routes/endpoint';
import { setMessageToast } from '../../../store/modules/parameter/actions';
import { useTranslation } from '../../../hooks/useTranslation';

const SignUpStep04: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const dispatch = useDispatch();
  const history = useHistory();
  // const [otherMail, setOtherMail] = useState('');
  const {
    user: {
      data: { first_name, last_name, email },
    },
    mailConfirm,
  } = useSelector((state: StoreState) => state.auth);
  const { onTranslation: t } = useTranslation();

  const handleSubmit = useCallback(
    async (data: CustomerData) => {
      try {
        //konsole.log(data);
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          conf_code: Yup.string()
            .required('Codigo obrigatório')
            .min(
              6,
              `${t('main.messages_yup.min')} 6 ${t(
                'main.messages_yup.digits',
              )}`,
            )
            .max(
              6,
              `${t('main.messages_yup.max')} 6 ${t(
                'main.messages_yup.digits',
              )}`,
            ),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        if (data.conf_code && email) {
          dispatch(customerConfirmMailRequest(data.conf_code, email));
        }
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRef.current?.setErrors(errors);
        }
      }
    },
    [dispatch, email, t],
  );

  const handleReEnviar = useCallback(async () => {
    const name = first_name + ' ' + last_name;
    if (email) {
      dispatch(customerSendMailRequest(name, email));
      await dispatch(
        setMessageToast({
          type: 'success', message: t('main.messages_toast.send_email_again')
        }),
      );
      //konsole.log(name, email);
    }
  }, [first_name, last_name, email, dispatch, t]);

  // const handleOuterEnviar = useCallback(async () => {
  //   try {
  //     const name = first_name + ' ' + last_name;

  //     const schema = Yup.object().shape({
  //       email: Yup.string()
  //         .required(t('main.messages_yup.email_required'))
  //         .email(t('main.messages_yup.email_invalid')),
  //     });

  //     await schema.validate(
  //       { email: otherMail },
  //       {
  //         abortEarly: false,
  //       },
  //     );

  //     if (otherMail) {
  //       await dispatch(customerSendMailRequest(name, otherMail));
  //       await dispatch(
  //         setMessageToast({
  //           type: 'success', message: t('main.messages_toast.send_email_again')
  //         }),
  //       );
  //     }
  //   } catch (err) {
  //     if (err instanceof Yup.ValidationError) {
  //       const errors = getValidationErrors(err);
  //       formRef.current?.setErrors(errors);
  //     }
  //   }
  // }, [first_name, last_name, otherMail, dispatch, t]);

  useEffect(() => {
    if (mailConfirm) history.push(routesEndpoints.CONFIRMATION_MAIL);
  }, [mailConfirm, history]);

  return (
    <Container>
      <Content>
        <AnimationContainer>
          <img src={config.logo} alt="ConectoVarejo" />
          <Form
            // initialData={{ conf_code: '385113' }}
            ref={formRef}
            onSubmit={handleSubmit}
          >
            <Title>
              <span>{t('main.modal_signup.signupstep04.title_01')}</span>
            </Title>

            <ColInput>
              <div style={{ marginBottom: '30px' }} />
            </ColInput>

            <ColInput>
              <p>
                {t('main.modal_signup.signupstep04.hello')}{' '}
                <b>{`${first_name} ${last_name}`}</b>{' '}
                {t('main.modal_signup.signupstep04.we_send')}
                <b>{` ${email} `}</b>{' '}
                {t('main.modal_signup.signupstep04.that_you_provided')}
              </p>
            </ColInput>

            <ColInput>
              <div style={{ marginBottom: '30px' }} />
            </ColInput>

            <ColInput>
              <Input
                icon={FiUser}
                name="conf_code"
                placeholder={t(
                  'main.modal_signup.signupstep04.placeholder_code',
                )}
              />
            </ColInput>

            <ColInput>
              <Button
                button={{ type: 'submit', name: 'confirmar' }}
                atributes={{
                  buttonType: 'success',
                  textColor: '#fff',
                  textSize: '30px',
                  borderColor: '#dddddd',
                }}
              >
                {t('main.modal_signup.signupstep04.button_confirm')}
              </Button>
            </ColInput>

            <ColInput>
              <div style={{ marginBottom: '30px' }} />
            </ColInput>

            <ColInput>
              <h3>{t('main.modal_signup.signupstep04.title_02')}</h3>
            </ColInput>

            <ColInput>
              <Button
                button={{ type: 'button', name: 'reenviar' }}
                onClick={() => handleReEnviar()}
                atributes={{
                  buttonType: 'warning',
                  textColor: '#000',
                  textSize: '30px',
                  borderColor: '#dddddd',
                }}
              >
                {t('main.modal_signup.signupstep04.button_resend')}
              </Button>
            </ColInput>

            <ColInput>
              <div style={{ marginBottom: '30px' }} />
            </ColInput>

            {/* <ColInput>
              <h3>{t('main.modal_signup.signupstep04.another_email')}</h3>
            </ColInput>

            <ColInput>
              <Input
                icon={FiMail}
                name="email"
                value={otherMail}
                onChange={e => setOtherMail(e.target.value)}
                placeholder={t(
                  'main.modal_signup.signupstep04.placeholder_email',
                )}
              />
              <Button
                button={{ type: 'button' }}
                onClick={() => handleOuterEnviar()}
                atributes={{
                  buttonType: 'primary',
                  textColor: '#fff',
                  textSize: '30px',
                  borderColor: '#dddddd',
                }}
              >
                {t('main.modal_signup.signupstep04.button_send')}
              </Button>
            </ColInput> */}
          </Form>
        </AnimationContainer>
      </Content>
    </Container>
  );
};

export default SignUpStep04;
